/* eslint-disable import/prefer-default-export */
export var DESKTOP_IMAGE_SIZES = [154, 190, 478];
export var MOBILE_IMAGE_SIZES = [300, 350, 666];
import { OV_CDN, OV_EMS_CDN } from '../../config/theme';
export var YMCA_PRODUCT_IDS = [6666355179598, 6666354425934, 6666777362510];
export var MEGA_FLEECE_PRODUCT_ID = 1407963332686;
export var SPRINGS_PRODUCT_ID = 6721668229;
export var COMING_SOON = 'COMING_SOON';
export var DETAILS = 'DETAILS';
export var NONE = 'NONE';
export var OPTIMIZE_TED_VIDEO_ID = '5AyJ4Ys9RAmNqg_3QZONWQ';
var CDN_HOST = "".concat(OV_CDN, "video/pdp/ted/");
var CDN_IMAGE_HOST = "".concat(OV_EMS_CDN, "media/videos/");
export var OPTIMIZE_TED_VIDEO_DATA = {
  black: {
    image: "".concat(CDN_IMAGE_HOST, "Black.jpg"),
    video: "".concat(CDN_HOST, "Black.mp4")
  },
  'black polka': {
    image: "".concat(CDN_IMAGE_HOST, "BlackPolka.jpg"),
    video: "".concat(CDN_HOST, "BlackPolka.mp4")
  },
  evergreen: {
    image: "".concat(CDN_IMAGE_HOST, "Evergreen.jpg"),
    video: "".concat(CDN_HOST, "Evergreen.mp4")
  },
  navy: {
    image: "".concat(CDN_IMAGE_HOST, "Navy.jpg"),
    video: "".concat(CDN_HOST, "Navy.mp4")
  },
  white: {
    image: "".concat(CDN_IMAGE_HOST, "White.jpg"),
    video: "".concat(CDN_HOST, "White.mp4")
  }
};
export var REVIEW_MIN = 5;
export var SELECT = 'SELECT';
export var SIZE_DOWN = 'DOWN';
export var SIZE_UP = 'UP';
export var SOLD_OUT = 'SOLD_OUT';
export var TECHNICAL_DETAILS = 'TECHNICAL_DETAILS';